var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "100%",
    viewBox: "0 0 22 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 32C8.8 34.475 6.82 36.5 4.4 36.5C1.98 36.5 0 34.475 0 32C0 29.525 1.98 27.5 4.4 27.5C6.82 27.5 8.8 29.525 8.8 32ZM4.4 14C1.98 14 0 16.025 0 18.5C0 20.975 1.98 23 4.4 23C6.82 23 8.8 20.975 8.8 18.5C8.8 16.025 6.82 14 4.4 14ZM4.4 0.5C1.98 0.5 0 2.525 0 5C0 7.475 1.98 9.5 4.4 9.5C6.82 9.5 8.8 7.475 8.8 5C8.8 2.525 6.82 0.5 4.4 0.5ZM17.6 9.5C20.02 9.5 22 7.475 22 5C22 2.525 20.02 0.5 17.6 0.5C15.18 0.5 13.2 2.525 13.2 5C13.2 7.475 15.18 9.5 17.6 9.5ZM17.6 14C15.18 14 13.2 16.025 13.2 18.5C13.2 20.975 15.18 23 17.6 23C20.02 23 22 20.975 22 18.5C22 16.025 20.02 14 17.6 14ZM17.6 27.5C15.18 27.5 13.2 29.525 13.2 32C13.2 34.475 15.18 36.5 17.6 36.5C20.02 36.5 22 34.475 22 32C22 29.525 20.02 27.5 17.6 27.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.5fbe0fd4.svg";
export { ForwardRef as ReactComponent };